import React from 'react'
import SubpageContact from "../components/SubpageContact";

function CoursePage() {
  return (
    <div className="bg-gray-50 dark:bg-[#0B0E0B]">
      <main>
        <div className="mt-16 mx-auto">
            <div className="video-container">
                <iframe className="video" src="https://www.youtube.com/embed/PObmNChjEVQ" title="Beaver Meadows Golf & Country Club" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            </div>
        </div>
      </main>
     
        
      
    </div>
  )
}

export default CoursePage